export { default } from './AccountTypeLabel';
